module.exports = __webpack_public_path__ + "assets/img/pdfPlaceholder.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pdfPlaceholder.png
// module id = 143
// module chunks = 0